import module from 'finanzas/module.js'

const schema = {
  Fecha: 'date',
  Fecha_Pago: 'date',
  Modificacion_Fecha: 'timestamp',
  Captura_Fecha: 'timestamp',
  Status: 'boolean',
  Comisionistas: {
    Comision: 'number',
    Total: 'number',
  },
  Nominas: {
    Subtotal: 'number',
    Comision_Porcentaje: 'number',
    Comision: 'number',
    IVA: 'number',
    Total: 'number',
  },
  Facturas: {
    Subtotal: 'number',
    Comision: 'number',
    IVA: 'number',
    Total: 'number',
  },
}

function FinanzasDetallesFacturacionService ($api, $window, $schema) {
  var FinanzasDetallesFacturacion = {}

  FinanzasDetallesFacturacion.$query = function (date) {
    return $api.post('kendu/nominas/detallesFacturacion/query', {
      date: date.toYMD(),
    }, {silent: true}).then(function (list) {
      return list.map(function (item) {
        return Format(item)
      })
    })
  }

  FinanzasDetallesFacturacion.$add = function (folio, data) {
    return $api.post('kendu/nominas/detallesFacturacion/add', {
      folio: folio || null,
      data: Format(data, true),
    }).then(function (data) {
      return Format(data)
    })
  }

  FinanzasDetallesFacturacion.$get = function (folio) {
    return $api.post('kendu/nominas/detallesFacturacion/get', {
      folio: folio,
    }).then(function (data) {
      return Format(data)
    })
  }

  FinanzasDetallesFacturacion.$export = function (folio) {
    $window.open('kendu/nominas/detallesFacturacion/export?folio=' + folio, '_blank')
  }

  function Format (data, encode) {
    return $schema(data, schema, encode)
  }

  return FinanzasDetallesFacturacion
}

module.service('FinanzasDetallesFacturacion', FinanzasDetallesFacturacionService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasDetallesFacturacion.js